const TAPKIT = !(window.location.host && [process.env.VUE_APP_OLD_APP_DOMAIN, process.env.VUE_APP_OLD_ROOT_DOMAIN, 'app.getfaraday.com', 'getfaraday.com', 'fara.fun', 'faraday-dev.web.app', 'faraday-c331f.web.app'].includes(window.location.host))

module.exports = {
  ENV: process.env.VUE_APP_FIREBASE_ENV,
  REGION: process.env.VUE_APP_FIREBASE_REGION,
  UNSPLASH_API_URL: 'https://api.unsplash.com',
  ACCESS_KEY: 'e886e49990bf62f3d9d3e2cf36eb1aa89b5db9070ebffd39b55d8eec195d7424',
  SECRET_KEY: '7ad34a5f8d9e39db7c9c577d5771d2805565ffd9b90311386089f5e8ced96027',
  STRIPE_KEY: process.env.VUE_APP_STRIPE_KEY,
  USER_SIGNUP_WEBHOOK: 'https://hooks.zapier.com/hooks/catch/9404686/3udn1ko/',
  TEST_PUBLISHED_WEBHOOK: 'https://hooks.zapier.com/hooks/catch/9404686/3udjb7r/',
  QR_CREATED_WEBHOOK: 'https://hooks.zapier.com/hooks/catch/9404686/3ud780j/',
  FEEDBACK_WEBHOOK: 'https://hooks.zapier.com/hooks/catch/9404686/3udj9zs/',
  MIXPANEL_KEY: '6db1632f37eb4b79ddefff8aa78f0b4b',
  GA_ID_APP: 'UA-154865940-2',
  GA_ID_LP: 'UA-154865940-3',
  PRISMIC_TOKEN: 'MC5YY1NCZ0JFQUFDRUE4YTFY.Sz8NDHNcUe-_ve-_vWUG77-9UXo677-977-9Ll8V77-9Ru-_vTJu77-9JhIg77-977-9XQ',
  TAPKIT: TAPKIT,
  APP_DOMAIN: TAPKIT ? process.env.VUE_APP_APP_DOMAIN : process.env.VUE_APP_OLD_APP_DOMAIN,
  ROOT_DOMAIN: TAPKIT ? process.env.VUE_APP_ROOT_DOMAIN : process.env.VUE_APP_OLD_ROOT_DOMAIN,
  LP_DOMAINS: process.env.VUE_APP_LP_DOMAINS ? process.env.VUE_APP_LP_DOMAINS.split('|') : [''],
  WHITELABEL_DOMAIN: TAPKIT ? process.env.VUE_APP_WHITELABEL_DOMAIN : process.env.VUE_APP_OLD_WHITELABEL_DOMAIN,
  WHITELABEL_IP: process.env.VUE_APP_WHITELABEL_IP,
  ZAPIER_INVITE: process.env.VUE_APP_ZAPIER_INVITE,
  SHOPIFY_PROXY_PREFIX: process.env.VUE_APP_SHOPIFY_PROXY_PREFIX,
  BUILDERTYPES: { FLOW: 'story', PAGE: 'page' },
  MFA_STATES: {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE'
  }
}
